<template>
    <v-container class="fill-height d-flex align-items-center justify-content-center min-vh-100">
        <div class="mx-auto text-center">
            <v-icon size="80" color="#fd7e14" class="mb-3 mt-3">
                mdi-alert
            </v-icon>
            <h4 class="text-center">
                No dispone de permisos necesarios para ver esta sección. Si es un error contacte al administrador.
            </h4>
        </div>
    </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>